import { lazy, Suspense } from 'react';
import { useSelector } from 'react-redux';
import { View } from 'foundations-components/components/View';
import { shouldShowBranding as shouldShowBrandingSelector } from 'FormsUI/selectors/Scope';
import { jsx as _jsx } from "react/jsx-runtime";
const UIUpgradeBanner = /*#__PURE__*/lazy(() => import('ui-addon-upgrades/ums/UIUpgradeBanner'));
const BrandingUpgradeBanner = ({
  upgradeKey,
  title
}) => {
  const shouldShowBranding = Boolean(useSelector(shouldShowBrandingSelector));
  if (!shouldShowBranding) {
    return null;
  }
  return /*#__PURE__*/_jsx(Suspense, {
    fallback: null,
    children: /*#__PURE__*/_jsx(View, {
      "data-test-id": "branding-upgrade-banner",
      padding: "0",
      paddingBlockEnd: "200",
      children: /*#__PURE__*/_jsx(UIUpgradeBanner, {
        upgradeKey: upgradeKey,
        showFTS002Variant: true,
        title: title
      })
    })
  });
};
export default BrandingUpgradeBanner;